import { render, staticRenderFns } from "./auto-message-create-new-dialog.vue?vue&type=template&id=8a071aea&scoped=true&"
import script from "./auto-message-create-new-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-message-create-new-dialog.vue?vue&type=script&lang=js&"
import style0 from "./auto-message-create-new-dialog.vue?vue&type=style&index=0&id=8a071aea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a071aea",
  null
  
)

export default component.exports